"use client"

import React, { ReactNode } from "react"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { DEFAULT_ACCOUNT_ARTICLES_PAGE_SIZES, SEARCH_PARAMS_PAGE, SEARCH_PARAMS_PAGE_SIZE } from "@/constants/ui"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { useTranslations } from "next-intl"

import { AccountContext } from "@/lib/storefront/account/account-service"
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/components"
import { DataPagination } from "@/components/ui/components/data-pagination"
import { getPaginationSearchParams } from "@/components/search-and-category/pagination-info"
import SearchResultPageSizeClient from "@/components/search-and-category/SearchResultPageSizeClient"
import SearchResultPagination from "@/components/search-and-category/SearchResultPagination"
import SearchResultPaginationClient from "@/components/search-and-category/SearchResultPaginationClient"
import SearchResultSortOrder from "@/components/search-and-category/SearchResultSortOrder"

interface AccountOrderListClientsProps {
  accountContext: AccountContext
  pageSize: number
  pageNumber: number
  productCards: ReactNode[]
  productsTotal: number
}

export default function AccountArticleListClient(props: AccountOrderListClientsProps) {
  const t = useTranslations("storefront")

  const searchParams = useSearchParams()
  const paginationSearchParams = getPaginationSearchParams(searchParams ?? undefined, true)
  const pathName = usePathname()
  const { replace } = useRouter()
  const { setIsLoading } = useUbStorefrontState()

  async function getPagedProducts(page: number) {
    const params = new URLSearchParams(searchParams)
    params.set(SEARCH_PARAMS_PAGE, page.toString())
    setIsLoading(true)
    replace(`${pathName}?${params.toString()}`)
  }
  function onPageSizeChange(pageSize: string) {
    const params = new URLSearchParams(searchParams)
    params.set(SEARCH_PARAMS_PAGE_SIZE, pageSize)
    setIsLoading(true)
    replace(`${pathName}?${params.toString()}`)
  }

  return (
    <>
      <div className={"relative flex w-full flex-col gap-4"}>
        <div className="flex w-full flex-row justify-start">
          <div className={"max-sm:hidden"}>
            <SearchResultPageSizeClient productsTotal={props.productsTotal} accountArticlesMode={true} />
          </div>
          <div className={"flex w-4/5 flex-row justify-center max-sm:w-full max-sm:justify-center "}>
            <SearchResultPaginationClient
              productsTotal={props.productsTotal}
              searchParams={searchParams}
              paginationSearchParams={paginationSearchParams}
            />
          </div>
        </div>

        <div className={"grid grid-cols-1 gap-4 lg:grid-cols-3"}>{props.productCards}</div>

        <DataPagination
          initialPage={props.pageNumber}
          totalPages={Math.ceil(props.productsTotal / props.pageSize)}
          onPageChange={(page) => getPagedProducts(page)}
        ></DataPagination>
      </div>
    </>
  )
}
